import React from 'react';
import glamorous from 'glamorous';

const GettingAccessToApiKey = () => (
  <div>
    <h3>
      Getting access to an API key
    </h3>
    <div>
      To receive an API key, please send your request to <a
      href="mailto:GlobalRecallsdata@oecd.org?subject=Global Recalls - API key request">GlobalRecallsdata@oecd.org</a> with
      the following information:
      <glamorous.Ul
        className="pt-list"
        css={{
          listStyle: 'disc',
        }}
      >
        <li>
          full name of the person associated with the API key (e.g. John Smith)
        </li>
        <li>
          one or several email addresses which will be used to send the integration reports (e.g.
          john.smith@consumerproductorg.fake)
        </li>
        <li>
          name of the institution requiring the API key (e.g. Consumer Protection Organisation)
        </li>
        <li>
          name(s) of the jurisdiction for which the API key will be used (e.g. FakeLand)
        </li>
        <li>
          modes of import required: update new recalls AND/OR modify existing recalls AND/OR delete existing recalls.
        </li>
      </glamorous.Ul>
    </div>
    <br/>
    <div className="pt-callout pt-intent-warning pt-icon-info-sign">
      <h5 className="pt-callout-title">IMPORTANT</h5>
      Your API key <strong>MUST</strong> be stored in a secure place, in order not to be hacked. Email addresses linked
      with an API key MUST be organisational ones. Personal/web-based emails will not be accepted.
      If you lose your API key or if you think it has been hacked, contact the OECD
      Secretariat <i>via</i> <a
      href="mailto:GlobalRecallsdata@oecd.org?subject=Global Recalls - lost API key">GlobalRecallsdata@oecd.org</a> to
      request for the generation of a new API key and the invalidation of the old one.
    </div>
  </div>
);

export default GettingAccessToApiKey;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/api-key/getting-access-to-api-key.js